import { useState, useEffect } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function AcceptInvitePage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const token = params.get("token");
  const [preview, setPreview] = useState(null);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) { setError("Kein Token in der URL"); return; }
    api.get(`/invites/preview/${token}`)
      .then(r => setPreview(r.data))
      .catch(e => setError(e.response?.data?.detail || "Einladung ungültig"));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/accept-invite", { token, password });
      toast.success("Willkommen!");
      await refresh();
      navigate("/");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Fehler");
    }
    setLoading(false);
  };

  if (error) return (
    <div className="min-h-screen flex items-center justify-center p-6" data-testid="accept-invite-error">
      <div className="rounded-xl border border-red-200 bg-red-50 p-6 max-w-md text-center">
        <div className="font-display text-xl font-semibold text-red-900 mb-2">Einladung ungültig</div>
        <p className="text-sm text-red-700">{error}</p>
        <Link to="/login" className="mt-4 inline-block text-sm underline">Zur Anmeldung</Link>
      </div>
    </div>
  );

  if (!preview) return <div className="min-h-screen flex items-center justify-center text-neutral-500">Lade Einladung…</div>;

  return (
    <div className="min-h-screen flex items-center justify-center p-6" data-testid="accept-invite-page">
      <div className="w-full max-w-md">
        <div className="text-xs uppercase tracking-[0.2em] text-neutral-500 font-semibold mb-2">Einladung</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mb-2">Willkommen bei {preview.tenant_name}</h1>
        <p className="text-neutral-600 mb-8">
          Hallo {preview.name}, du wurdest als <strong>{preview.role}</strong> eingeladen. Lege ein Passwort fest, um dein Konto zu aktivieren.
        </p>
        <form onSubmit={submit} className="space-y-4">
          <div><Label>E-Mail</Label><Input value={preview.email} disabled /></div>
          <div><Label>Passwort</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} minLength={6} required data-testid="accept-password" /></div>
          <Button type="submit" className="w-full" disabled={loading} data-testid="accept-submit">{loading ? "…" : "Konto aktivieren"}</Button>
        </form>
      </div>
    </div>
  );
}
